import React from 'react'

function Kontakt() {
  return (
    <div className='contact-container'>
      <h1>Kontakt</h1>
      <h2>Bernard Łach </h2>
      <p>tel. 663-000-177</p>
      <h2>Piotr Kokosza  </h2>
      <p>tel. 600-558-387 </p>

      </div>
  )
}

export default Kontakt